// Keep the existing imports for other libraries
require('./bootstrap');
require('alpinejs');

require('../assets/plugins/chart/chart.bundle.js');
require('../assets/plugins/chart/utils.js');

require('../assets/plugins/simplebar/js/simplebar.min.js');

require('./mobile-menu');
require('./sidemenu');

require('../assets/js/custom.js');
require('@fortawesome/fontawesome-pro/js/all');

import { createApp } from 'vue'; // Vue 3 uses createApp instead of new Vue()
import dayjs from 'dayjs';
import 'dayjs/locale/sk';
import summernote from 'summernote';

import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import skLocale from '@fullcalendar/core/locales/sk';

window.Calendar         = Calendar;
window.dayGridPlugin    = dayGridPlugin;
window.interactionPlugin    = interactionPlugin;
window.bootstrap5Plugin = bootstrap5Plugin;
window.timeGridPlugin   = timeGridPlugin;
window.listPlugin       = listPlugin;
window.skLocale         = skLocale;

require('jquery-ui/ui/widget');
require('jquery-ui/ui/scroll-parent');
require('jquery-ui/ui/data');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/sortable');
require('select2');

const Swal = window.Swal = require('sweetalert2');
require('select2/dist/js/select2.full.min');
require('./jquery.print.min');

window.Sortable = require('sortablejs').Sortable;

window.cms = {
    mediaPickerCount: 0,
    mediaPickers: {}
};

let relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);

window.dayjs = dayjs;

// Import your Vue components (assuming they are still compatible with Vue 3)
import LinkPicker from '../components/LinkPicker.vue';
import ImagePicker from '../components/ImagePicker.vue';
import MultiImagePicker from '../components/MultiImagePicker.vue';

// Create the Vue app
const app = createApp({
    components: {
        LinkPicker,
        ImagePicker,
        MultiImagePicker
    }
});

// Mount the Vue app to the #app element
app.mount('#app');

// Store the app globally for use in other places (optional)
window.vueApp = app;

// Initialize PerfectScrollbar
import PerfectScrollbar from 'perfect-scrollbar';

$(document).ready(function () {
    $('.select2').select2();

    const ps = new PerfectScrollbar('.app-sidebar', {
        useBothWheelAxes: true,
        suppressScrollX: true,
    });
});

// jQuery and event listeners
$('body').on('click', '.forceJsPrint', function (e) {
    e.preventDefault();
    $(this).doPrintPage({
        attr: 'href',
        message: 'Váš dokument sa pripravuje na tlač.'
    });
});

// Utility functions
window.replaceCommaToDot = function (target, event) {
    $(target).val($(target).val().replace(',', '.'));
};

window.isNumberKey = function (txt, evt) {
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 44 || charCode == 188) {
        if ((txt.value.indexOf(',') == -1 && txt.value.indexOf('.') == -1) && txt.value.length > 0) {
            return true;
        }
        return false;
    } else if (charCode == 46 || charCode == 190 || charCode == 110) {
        if ((txt.value.indexOf(',') == -1 && txt.value.indexOf('.') == -1) && txt.value.length > 0) {
            return true;
        }
        return false;
    } else {
        if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
            return true;
        }
        return false;
    }
    return true;
};
